module.exports = __webpack_public_path__ + "static/img/newDialog-7.8e297cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/newDialog-7.png
// module id = AkKk
// module chunks = 1